class CardMobileSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.card-mobile-slider__track');
    this.dots = el.querySelectorAll('.card-mobile-slider__dot');
    this.count = el.querySelectorAll('.card-mobile-slider__slide').length;

    // Récupère le lien produit pour la navigation au tap
    const cardWrapper = el.closest('.card-wrapper');
    this.productLink = cardWrapper ? cardWrapper.querySelector('a[id^="CardLink"]') : null;

    if (this.count > 1 && this.dots.length) {
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }

    // Tap = navigation, swipe = slider
    let startX = 0, startY = 0;
    el.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    el.addEventListener('touchend', (e) => {
      const dx = Math.abs(e.changedTouches[0].clientX - startX);
      const dy = Math.abs(e.changedTouches[0].clientY - startY);
      if (dx < 10 && dy < 10 && this.productLink) {
        window.location.href = this.productLink.href;
      }
    }, { passive: true });
  }

  onScroll() {
    const index = Math.round(this.track.scrollLeft / this.track.offsetWidth);
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('card-mobile-slider__dot--active', i === index);
    });
  }
}

function initCardMobileSliders(scope) {
  (scope || document).querySelectorAll('.card-mobile-slider:not([data-slider-init])').forEach(el => {
    el.setAttribute('data-slider-init', '');
    new CardMobileSlider(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCardMobileSliders());
} else {
  initCardMobileSliders();
}
